if (!customElements.get('collection-card-gallery')) {
  customElements.define(
    'collection-card-gallery',
    class CollectionCardGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.galleryInitialized === 'true') return;
        this.dataset.galleryInitialized = 'true';

        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
        this.currentIndex = 0;
        this.pointerStartX = null;
        this.pointerStartY = null;
        this.suppressNextClick = false;

        this.querySelector('[data-gallery-previous]')?.addEventListener('click', (event) => {
          this.handleNavigation(event, -1);
        });
        this.querySelector('[data-gallery-next]')?.addEventListener('click', (event) => {
          this.handleNavigation(event, 1);
        });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showSlide(Number(dot.dataset.slideIndex));
          });
        });

        this.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button')) return;
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
        });
        this.addEventListener('pointerup', (event) => this.handlePointerUp(event));
        this.addEventListener('pointercancel', () => this.resetPointer());
        this.addEventListener('click', (event) => this.handleGalleryClick(event));
      }

      handleNavigation(event, direction) {
        event.preventDefault();
        event.stopPropagation();

        if (this.slides.length < 2) return;

        this.showSlide((this.currentIndex + direction + this.slides.length) % this.slides.length);
      }

      showSlide(index) {
        if (!Number.isInteger(index) || index < 0 || index >= this.slides.length) return;

        this.slides[this.currentIndex].hidden = true;
        this.slides[this.currentIndex].classList.remove('is-active');
        this.dots[this.currentIndex]?.classList.remove('is-active');
        this.dots[this.currentIndex]?.removeAttribute('aria-current');
        this.currentIndex = index;
        this.slides[this.currentIndex].hidden = false;
        this.slides[this.currentIndex].classList.add('is-active');
        this.dots[this.currentIndex]?.classList.add('is-active');
        this.dots[this.currentIndex]?.setAttribute('aria-current', 'true');
      }

      handlePointerUp(event) {
        if (this.pointerStartX === null || this.pointerStartY === null) return;

        const distanceX = event.clientX - this.pointerStartX;
        const distanceY = event.clientY - this.pointerStartY;
        this.resetPointer();

        if (Math.abs(distanceX) < 35 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

        this.suppressNextClick = true;
        this.handleNavigation(event, distanceX < 0 ? 1 : -1);
      }

      handleGalleryClick(event) {
        if (event.target.closest('button')) return;

        if (this.suppressNextClick) {
          event.preventDefault();
          this.suppressNextClick = false;
          return;
        }

        if (window.matchMedia('(max-width: 749px)').matches && this.dataset.productUrl) {
          window.location.assign(this.dataset.productUrl);
        }
      }

      resetPointer() {
        this.pointerStartX = null;
        this.pointerStartY = null;
      }
    }
  );
}
